module.exports = "/packs/step3-9f56950a7b408587566f4c2727ddec35.png";